import styles from './Advantages.module.scss'
import { motion } from "framer-motion"

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Advantages = () => {

    return (
        <motion.section 
        className={styles.main}
        id='preimushchestva' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >  
        <div className={styles.container}>
        <motion.h2 className={styles.title} variants={titleAnimation}><span>6 ключевых преимуществ</span> по&nbsp;которым заказчики выбирают нас</motion.h2>
        <motion.ul className={styles.list}>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>01</p>
                            <p className={styles.item_title}>Доступные цены</p>
                        </div>
                        <p className={styles.item_text}>Мы не посредники – мы исполнители. Обращаясь к нам напрямую, Вы получаете самую низкую цену, избегая услуг посредников. Мы не в праве изменять сметы по своему желанию и под любыми предлогами. У Вас всегда будет 100% уверенности в том, что запланированных средств хватит для полного завершения работ.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>02</p>
                            <p className={styles.item_title}>Соблюдение сроков</p>
                        </div>
                        <p className={styles.item_text}>Если в договоре прописано, что работы будут закончены за 10 дней – значит так и будет. Мы сделаем все возможное, чтобы работы были закончены в срок, а Вы могли спокойно заниматься своими важными делами, оставаясь в зоне комфорта.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>03</p>
                            <p className={styles.item_title}>Гарантия качества</p>
                        </div>
                        <p className={styles.item_text}>На все выполненные работы даем гарантию 5 лет, которая зафиксирована в договоре. Это значит, что в течении 1825 дней мы устраним возникшие проблемы за свой счет. Мы уверены в компетенциях наших мастеров и осуществляем четкий контроль на каждом этапе проведения работ.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>04</p>
                            <p className={styles.item_title}>Качество материалов</p>
                        </div>
                        <p className={styles.item_text}>Работаем на прямую только с крупными и проверенными производителями кровельных материалов. Вся продукция имеет заводскую маркировку. Оригинальность продукции можно проверить через сайты заводов-производителей по номеру заказа или звонком на горячую линию.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>05</p>
                            <p className={styles.item_title}>Чистота и порядок</p>
                        </div>
                        <p className={styles.item_text}>Мы с уважаем относимся к имуществу наших клиентов. Закончив работу, соберем весь строительный мусор, упакуем, погрузим в транспорт и вывезем с участка. Гарантируем сохранность садовых дорожек, розовых кустов и английского газона.</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <div className={styles.item_box} >
                            <p className={styles.item_number}>06</p>
                            <p className={styles.item_title}>Гибкий график</p>
                        </div>
                        <p className={styles.item_text}>Если необходимо работаем в выходные и праздничные дни. Рано утром и поздно вечером. Время работы ограничено только внутренним распорядком клиента.</p>
                    </motion.li>
                </motion.ul>
        </div>   
    </motion.section>
    )
}

export default Advantages